import React from 'react'
import cn from '#/utils/classnames'
import styles from './styles.module.css'

const Line = () => (
  <div className='border-b border-gray-100 border-opacity-95' />
)

const GraphLines = () => (
  <div className='absolute flex h-full w-full flex-col justify-between px-8'>
    <Line />
    <Line />
    <Line />
    <Line />
    <Line />
  </div>
)

const DynamicGraphBars = () => (
  <div className='relative flex h-full items-baseline space-x-1 rounded'>
    <div className='h-[8%] flex-1 rounded bg-gray-200 bg-opacity-60' />
    <div className='h-[30%] flex-1 rounded bg-gray-200 bg-opacity-60' />
    <div className='h-[48%] flex-1 rounded bg-gray-200 bg-opacity-60' />
    <div className='h-[84%] flex-1 rounded bg-gray-200 bg-opacity-60' />
    <div className='h-[92%] flex-1 rounded bg-gray-200 bg-opacity-60' />
    <div className='h-[68%] flex-1 rounded bg-gray-200 bg-opacity-60' />
    <div className='h-[52%] flex-1 rounded bg-gray-200 bg-opacity-60' />
    <div className='h-[56%] flex-1 rounded bg-gray-200 bg-opacity-60' />
    <div className='h-[36%] flex-1 rounded bg-gray-200 bg-opacity-60' />
    <div className='h-[32%] flex-1 rounded bg-gray-200 bg-opacity-60' />
    <div className='h-[18%] flex-1 rounded bg-gray-200 bg-opacity-60' />
    <div className='h-[15%] flex-1 rounded bg-gray-200 bg-opacity-60' />
    <div className='h-[14%] flex-1 rounded bg-gray-200 bg-opacity-60' />
    <div className='tranparent h-[100%] flex-1 rounded bg-opacity-60' />
    <div className='h-[4%] flex-1 rounded bg-gray-200 bg-opacity-60' />
  </div>
)

const LargeGraphBars = () => (
  <div className='relative flex h-full items-baseline space-x-1 rounded'>
    <div className='h-72 flex-1 rounded bg-transparent' />
    <div className='h-20 flex-1 rounded bg-transparent xl:bg-gray-200 xl:bg-opacity-60' />
    <div className='h-28 flex-1 rounded bg-gray-200 bg-opacity-60' />
    <div className='h-64 flex-1 rounded bg-gray-200 bg-opacity-60' />
    <div className='h-72 flex-1 rounded bg-gray-200 bg-opacity-60' />
    <div className='h-48 flex-1 rounded bg-gray-200 bg-opacity-60' />
    <div className='h-32 flex-1 rounded bg-gray-200 bg-opacity-60' />
    <div className='h-36 flex-1 rounded bg-gray-200 bg-opacity-60' />
    <div className='h-16 flex-1 rounded bg-gray-200 bg-opacity-60' />
    <div className='h-12 flex-1 rounded bg-gray-200 bg-opacity-60' />
    <div className='h-8 flex-1 rounded bg-gray-200 bg-opacity-60' />
    <div className='h-5 flex-1 rounded bg-gray-200 bg-opacity-60' />
    <div className='h-4 flex-1 rounded bg-gray-200 bg-opacity-60' />
    <div className='h-2 flex-1 rounded bg-transparent xl:bg-gray-200 xl:bg-opacity-60' />
    <div className='h-0 flex-1 rounded bg-gray-200 bg-opacity-60' />
  </div>
)
const MediumGraphBars = () => (
  <div className='relative my-3 flex h-full items-baseline space-x-1 rounded'>
    <div className='h-10 flex-1 rounded bg-transparent' />
    <div className='h-10 flex-1 rounded bg-transparent xl:bg-gray-200 xl:bg-opacity-60' />
    <div className='h-20 flex-1 rounded bg-gray-200 bg-opacity-60' />
    <div className='h-24 flex-1 rounded bg-gray-200 bg-opacity-60' />
    <div className='h-32 flex-1 rounded bg-gray-200 bg-opacity-60' />
    <div className='h-48 flex-1 rounded bg-gray-200 bg-opacity-60' />
    <div className='h-32 flex-1 rounded bg-gray-200 bg-opacity-60' />
    <div className='h-36 flex-1 rounded bg-gray-200 bg-opacity-60' />
    <div className='h-16 flex-1 rounded bg-gray-200 bg-opacity-60' />
    <div className='h-12 flex-1 rounded bg-gray-200 bg-opacity-60' />
    <div className='h-8 flex-1 rounded bg-gray-200 bg-opacity-60' />
    <div className='h-5 flex-1 rounded bg-gray-200 bg-opacity-60' />
    <div className='h-4 flex-1 rounded bg-gray-200 bg-opacity-60' />
    <div className='h-2 flex-1 rounded bg-transparent xl:bg-gray-200 xl:bg-opacity-60' />
    <div className='h-0 flex-1 rounded bg-gray-200 bg-opacity-60' />
  </div>
)
const SmallGraphBars = () => (
  <div className='relative flex h-full items-baseline space-x-1 rounded'>
    <div className='h-[100px] flex-1 rounded bg-transparent' />
    <div className='h-2 flex-1 rounded bg-transparent xl:bg-gray-200 xl:bg-opacity-60' />
    <div className='h-2 flex-1 rounded bg-gray-200 bg-opacity-60' />
    <div className='h-2 flex-1 rounded bg-transparent xl:bg-gray-200 xl:bg-opacity-60' />
    <div className='h-4 flex-1 rounded bg-transparent xl:bg-gray-200 xl:bg-opacity-60' />
    <div className='h-4 flex-1 rounded bg-transparent xl:bg-gray-200 xl:bg-opacity-60' />
    <div className='h-2 flex-1 rounded bg-transparent xl:bg-gray-200 xl:bg-opacity-60' />
    <div className='h-8 flex-1 rounded bg-gray-200 bg-opacity-60' />
    <div className='h-6 flex-1 rounded bg-gray-200 bg-opacity-60' />
    <div className='h-16 flex-1 rounded bg-gray-200 bg-opacity-60' />
    <div className='h-20 flex-1 rounded bg-gray-200 bg-opacity-60' />
    <div className='h-16 flex-1 rounded bg-gray-200 bg-opacity-60' />
    <div className='h-6 flex-1 rounded bg-gray-200 bg-opacity-60' />
    <div className='h-2 flex-1 rounded bg-gray-200 bg-opacity-60' />
    <div className='h-8 flex-1 rounded bg-gray-200 bg-opacity-60' />
    <div className='h-5 flex-1 rounded bg-gray-200 bg-opacity-60' />
    <div className='h-4 flex-1 rounded bg-gray-200 bg-opacity-60' />
    <div className='h-2 flex-1 rounded bg-transparent xl:bg-gray-200 xl:bg-opacity-60' />
    <div className='h-6 flex-1 rounded bg-transparent xl:bg-gray-200 xl:bg-opacity-60' />
    <div className='h-4 flex-1 rounded bg-transparent xl:bg-gray-200 xl:bg-opacity-60' />
    <div className='h-2 flex-1 rounded bg-transparent xl:bg-gray-200 xl:bg-opacity-60' />
    <div className='h-2 flex-1 rounded bg-transparent xl:bg-gray-200 xl:bg-opacity-60' />
    <div className='h-0 flex-1 rounded bg-gray-200 bg-opacity-60' />
  </div>
)

export default function BarGraphSkeleton({ size = 'large' }: { size?: 'small' | 'medium' | 'large' | 'dynamic' }) {
  const choosePropertSkeleton = () => {
    switch (size) {
      case 'small':
        return (<SmallGraphBars />)
      case 'medium':
        return (<MediumGraphBars />)
      case 'large':
        return (<LargeGraphBars />)
      default:
        return (<DynamicGraphBars />)
    }
  }
  return (
    <div
      className={cn(
        'flex items-baseline space-x-1',
        styles['th-bar-graph'],
        { 'py-8 m-6': size !== 'small' && size !== 'medium' },
        { 'my-3': size === 'medium' },
        { 'h-[100px]': size === 'small' },
        { 'h-full p-0 m-0': size === 'dynamic' }
      )}
    >
      <div className={cn('relative w-full rounded', styles['th-shim-bar-gray'], { 'h-full': size === 'dynamic' })}>
        <GraphLines />
        {
          choosePropertSkeleton()
        }
      </div>
    </div>
  )
}
